"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKIllustrationMapping = exports.GKIllustrationName = void 0;
var Illustrations_1 = __importDefault(require("./Illustrations"));
var GKIllustrationName;
(function (GKIllustrationName) {
    GKIllustrationName["CloudCover"] = "cloud-cover";
    GKIllustrationName["DocumentCheck"] = "document-check";
    GKIllustrationName["Document"] = "document";
    GKIllustrationName["EmailConfirmed"] = "email-confirmed";
    GKIllustrationName["Email"] = "email";
    GKIllustrationName["EmailOpen"] = "email-open";
    GKIllustrationName["FieldLayers"] = "field-layers";
    GKIllustrationName["Field"] = "field";
    GKIllustrationName["Key"] = "key";
    GKIllustrationName["LockedCheck"] = "locked-check";
    GKIllustrationName["Locked"] = "locked";
    GKIllustrationName["People"] = "people";
    GKIllustrationName["Satellite"] = "satellite";
    GKIllustrationName["UnlockedCheck"] = "unlocked-check";
    GKIllustrationName["Unlocked"] = "unlocked";
})(GKIllustrationName = exports.GKIllustrationName || (exports.GKIllustrationName = {}));
exports.GKIllustrationMapping = (_a = {},
    _a[GKIllustrationName.CloudCover] = {
        src: Illustrations_1.default.GILCloudCover,
        alt: "cloud cover",
    },
    _a[GKIllustrationName.DocumentCheck] = {
        src: Illustrations_1.default.GILDocumentCheck,
        alt: "document check",
    },
    _a[GKIllustrationName.Document] = {
        src: Illustrations_1.default.GILDocument,
        alt: "document",
    },
    _a[GKIllustrationName.EmailConfirmed] = {
        src: Illustrations_1.default.GILEmailConfirmed,
        alt: "email confirmed",
    },
    _a[GKIllustrationName.EmailOpen] = {
        src: Illustrations_1.default.GILEmailOpen,
        alt: "email open",
    },
    _a[GKIllustrationName.Email] = { src: Illustrations_1.default.GILEmail, alt: "email" },
    _a[GKIllustrationName.FieldLayers] = {
        src: Illustrations_1.default.GILFieldLayers,
        alt: "field layers",
    },
    _a[GKIllustrationName.Field] = { src: Illustrations_1.default.GILField, alt: "field" },
    _a[GKIllustrationName.Key] = { src: Illustrations_1.default.GILKey, alt: "key" },
    _a[GKIllustrationName.LockedCheck] = {
        src: Illustrations_1.default.GILLockedCheck,
        alt: "locked check",
    },
    _a[GKIllustrationName.Locked] = { src: Illustrations_1.default.GILLocked, alt: "locked" },
    _a[GKIllustrationName.People] = { src: Illustrations_1.default.GILPeople, alt: "people" },
    _a[GKIllustrationName.Satellite] = {
        src: Illustrations_1.default.GILSatellite,
        alt: "satellite",
    },
    _a[GKIllustrationName.UnlockedCheck] = {
        src: Illustrations_1.default.GILUnlockedCheck,
        alt: "unlocked check",
    },
    _a[GKIllustrationName.Unlocked] = {
        src: Illustrations_1.default.GILUnlocked,
        alt: "unlocked",
    },
    _a);
